// El contador de un campo con tope de caracteres (`maxLength`): sin él, al llegar al límite el campo dejaba de
// aceptar texto sin decir nada. Aparece cuando ya se usó el 80 % (no ensucia los campos cortos de siempre) y avisa
// al llegar al tope. `role="status"` para que el lector de pantalla lo lea sin cortar lo que se escribe.
import { ayuda, aviso } from './estilos';

export const UMBRAL_DEL_CONTADOR = 0.8;

export function ContadorDeLimite({ largo, max }: { largo: number; max: number }) {
  if (largo < Math.floor(max * UMBRAL_DEL_CONTADOR)) return null;
  const alTope = largo >= max;
  return (
    <div
      data-testid="contador-de-limite"
      role="status"
      style={{ ...(alTope ? aviso : ayuda), textAlign: 'right' }}
    >
      {alTope ? `Llegaste al máximo: ${max} caracteres` : `${largo} / ${max}`}
    </div>
  );
}
